<template>
  <b-card>
    <b-table
      show-empty
      head-variant="dark"
      striped
      hover
      bordered
      :items="items"
      :fields="fields"
    >
      <template v-slot:cell(no)="data">
        {{ data.index + 1 }}
      </template>
      <template v-slot:cell(action)="data">
        <span>
          <b-button
            variant="primary"
            size="sm"
            @click="onClickDelete(data.index)"
            >DELETE</b-button
          >
        </span>
      </template>
    </b-table>
  </b-card>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    fields: {
      type: Array,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    week: {
      type: [String, Number],
      required: true
    }
  },
  methods: {
    onClickDelete(index) {
      this.$emit("delete", { index: index, week: String(this.week) });
    }
  }
};
</script>
<style lang="css" scoped></style>
